export enum Style {
    Warning = "Warning",
    Normal = "Normal"
}